<template>
  <b-container fluid class="mt-2">
    <!-- search form -->
    <b-card-header>

      <b-form>
        <b-row class="align-tableData-center mb-2">
          <b-col cols="auto">
            <label for="period" class="font-weight-900 text-sm">Calling Number:</label>
          </b-col>
          <b-col cols="auto">
            <b-form-input
                id="callingNumber"
                type="number"
                size="sm"
                :state="callingNumberState"
                v-model="queryForm.callingNumber"
                placeholder="digits only"
            ></b-form-input>
          </b-col>

          <b-col cols="auto">
            <label for="period" class="font-weight-900 text-sm">Called Number:</label>
          </b-col>
          <b-col cols="auto">
            <b-form-input
                id="calledNumber"
                type="number"
                size="sm"
                :state="calledNumberState"
                v-model="queryForm.calledNumber"
                placeholder="digits only"
            ></b-form-input>
          </b-col>
          <b-col cols="auto">
            <label for="period" class="font-weight-900 text-sm">Error Code:</label>
          </b-col>
          <b-col cols="auto">
            <b-form-input
                id="error"
                type="number"
                size="sm"
                placeholder="Error Code Number"
                :state="causeCodeState"
                v-model="queryForm.causeCode"
            ></b-form-input>
            <small>testing: 4062631807 and 2023-08-04</small>
          </b-col>
          <b-col class="text-right">
            <base-button
                size="sm"
                type="primary"
                title="Search"
                :disabled="disabledSearch"
                v-on:click="searchSubmit"
                :loading="loadingStatus">
              <i v-if="!loadingStatus" class="fas fa-search"> </i> Search
            </base-button>
          </b-col>
        </b-row>
        <b-row class="mb-0">
          <b-col>
            <label for="period" class="font-weight-900 text-sm">Date Range:</label>
          </b-col>
        </b-row>
        <b-row class="align-tableData-center py-2 bg-light-form">
          <b-col cols="2">
            <b-form-radio name="most-recent" v-model="selected" value="mostRecent">Most Recent</b-form-radio>
          </b-col>
          <b-col cols="auto">
            <b-form-radio name="15-mins" v-model="subSelected" :disabled="selected !== 'mostRecent'"
                          :value="mostRecentSubVal? '15':null">15 mins
            </b-form-radio>
          </b-col>
          <b-col cols="auto">
            <b-form-radio name="30-mins" v-model="subSelected" :disabled="selected !== 'mostRecent'"
                          :value="mostRecentSubVal? '30':null">30 mins
            </b-form-radio>
          </b-col>
          <b-col cols="auto">
            <b-form-radio name="60-mins" v-model="subSelected" :disabled="selected !== 'mostRecent'"
                          :value="mostRecentSubVal? '60':null">1 hour
            </b-form-radio>
          </b-col>
          <b-col cols="auto">
            <b-form-radio name="120-mins" v-model="subSelected" :disabled="selected !== 'mostRecent'"
                          :value="mostRecentSubVal? '120':null">2 hours
            </b-form-radio>
          </b-col>
        </b-row>
        <b-row class="align-tableData-center py-4 mt-2 bg-light-form">
          <b-col cols="2">
            <b-form-radio name="today" v-model="selected" value="today">Today</b-form-radio>
            <b-form-radio name="yesterday" v-model="selected" value="yesterday">Yesterday</b-form-radio>
            <b-form-radio name="new-date" v-model="selected" value="customDate">
              <b-form-input size="sm" class="disabled-input" :disabled="selected !== 'customDate'" v-model="customDay"
                            type="date"></b-form-input>
            </b-form-radio>
          </b-col>
          <b-col cols="auto">
            <label for="start-time" class="text-sm">Start Time:</label>
            <b-form-timepicker size="sm" class="start-end-time" name="start-time" local="en" :disabled="!todaySubVal"
                               v-model="startTime"></b-form-timepicker>
          </b-col>
          <b-col cols="auto">
            <label for="end-time" class="text-sm">End Time:</label>
            <b-form-timepicker size="sm" class="start-end-time" name="end-time" local="en" :disabled="!todaySubVal"
                               v-model="endTime"></b-form-timepicker>
          </b-col>
        </b-row>
        <b-row class="align-tableData-center py-2 mt-2 bg-light-form">
          <b-col cols="2">
            <b-form-radio name="custom" v-model="selected" value="customRange">Custom Range</b-form-radio>
          </b-col>
          <b-col cols="auto">
            <label for="fromDate" class="text-sm">From Date:</label>
            <b-form-input class="disabled-input" v-model="customFromDate" :disabled="!customSubVal" size="sm"
                          type="datetime-local" id="fromDate"/>
          </b-col>
          <b-col cols="auto">
            <label for="toDate" class="text-sm">To Date:</label>
            <b-form-input class="disabled-input" v-model="customToDate" :disabled="!customSubVal" size="sm"
                          type="datetime-local"
                          id="toDate"/>
          </b-col>
        </b-row>
      </b-form>
    </b-card-header>

    <b-card-body>
      <!-- results container -->
      <transition name="slide-fade" v-if="rfReportDisplayStatus">
        <div>
          <div v-if="loadingStatus" class="text-center w-100">
            <b-icon
                icon="three-dots"
                class="text-center"
                animation="cylon"
                font-scale="4"
            ></b-icon>
          </div>
          <div v-else class="mb-3">
            <b-row>
              <b-col cols="12" xl="4" lg="4" md="4" sm="4">
                <b-form-group
                    label=""
                    label-for="per-page-select"
                    label-cols-sm="0"
                    label-cols-md="0"
                    label-cols-lg="0"
                    label-align-sm="center"
                    label-size="sm"
                    class="mb-2 per-page-select"
                >
                  <label for="per-page-select" class="mr-2 text-sm mt-1 mr-4">Show</label>
                  <b-form-select
                      id="per-page-select"
                      class="rf-report-select"
                      v-model="perPage"
                      :options="pageOptions"
                      size="sm"
                      v-on:input="changePageOption(perPage)"
                  ></b-form-select>
                </b-form-group>
              </b-col>
              <b-col cols="12" xl="4" lg="3" md="3" sm="3" class="text-center">
              </b-col>
              <b-col cols="12" xl="4" lg="5" md="5" sm="5" class="customer-table-select">
                <b-form-group
                    label=""
                    label-for="filter-input"
                    label-align-sm="right"
                    label-size="sm "
                    class="mb-0 per-page-select"
                >
                  <label for="filter-input" class="text-sm mr-2 mt-1">Filter:</label>
                  <b-input-group size="sm">
                    <b-form-input id="filter-input2" v-model="filter" class="mb-4"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <div>
              <!-- results table -->
              <div>
                <b-table
                    :items="tableData"
                    :fields="tableColumns"
                    :current-page="currentPage"
                    :per-page="perPage"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :sort-direction="sortDirection"
                    head-variant="light"
                    table-class="text-nowrap"
                    class="data-management-table primary-table"
                    sticky-header="true"
                    thead-class="white"
                    show-empty
                    responsive
                    small
                    striped
                    hover
                >
                  <template #cell(details)="row">
                    <b-button size="sm" variant="info" v-on:click="showModal(row)" title="View Details">
                      <b-icon icon="binoculars" aria-hidden="true"></b-icon>
                    </b-button>
                  </template>
                </b-table>
              </div>
              <!-- pager -->
              <b-row class="mt-4">
                <b-col>
                  <p class="ml-3 nowrap">Results {{ startPage() }} - {{ lastPage() }} of {{ totalRows }}</p>
                </b-col>
                <b-col>
                  <b-pagination
                      class="flex-fill-custom pr-4 ml-3 justify-content-end"
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      size="sm"
                  ></b-pagination>
                </b-col>
              </b-row>
            </div>
            <!-- Info modal -->
            <b-modal title="Details" ok-only centered id="rf-details_modal" size="lg">
              <b-tabs content-class="mt-3">
                <b-tab title="FIELDS" active>
                      <div class="data-management-table primary-table b-table-sticky-header table-responsive">
                          <table class="table b-table text-nowrap table-striped table-hover table-sm">
                            <thead class="thead-light white">
                            <th>Name</th>
                            <th>Value</th>
                            </thead>
                          <tbody v-for="(value, index) in tbContent"
                                 :key="index">
                          <tr class="b-table">
                            <td class="bg-light">{{ value[0] }}</td>
                            <td>{{ value[1][0] }}</td>
                          </tr>
                          </tbody>
                          </table>

                      </div>
                </b-tab>
                <b-tab title="RAW">
                  <span class="responsive-table">
                    <div v-highlight class="overflow-auto w-auto h-auto">
                          <pre><code class="json">{{
                              printJson(modalContent)
                            }}</code></pre>
                    </div>
                  </span>
                </b-tab>
              </b-tabs>
            </b-modal>
          </div>
        </div>
      </transition>

    </b-card-body>
  </b-container>
</template>
<script>
import {Option, Select} from "element-ui";
import moment from "moment";
import rfDashboardService from '../../../../common/api-services/rf-dashboard-service';
import ToastVue from "../../../Components/Toast";
import jsPDF from "jspdf";
import pagination from "@/common/format/pagination";
import commonService from "@/common/api-services/common";
import coreutils from "@/common/coreutils";

export default {
  name: "RfSearch",
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ToastVue
  },
  data() {
    return {
      tbContent: [],
      tbFields: [
        {key: 'key', label: 'Name'},
        {key: 'val', label: 'Data'}
      ],
      rfReportDisplayStatus: false,
      formData: {},
      queryForm: {
        fromDate: "",
        toDate: "",
        callingNumber: "",
        calledNumber: "",
        causeCode: "",
        result_type: "table"
      },
      dateRange: {
        mostRecent: true,
        today: false,
        yesterday: false,
        customDate: false,
        customRange: false,
      },
      selected: "mostRecent",
      subSelected: "15",
      startTime: "",
      endTime: "",
      customDay: "",
      customToDate: "",
      customFromDate: "",
      error: "*",
      type: "",
      rowLimitOption: [
        {key: "10", value: "10"},
        {key: "25", value: "25"},
        {key: "50", value: "50"},
        {key: "100", value: "100"},
      ],
      orderOption: [
        {key: "Ascending", value: "asc"},
        {key: "Descending", value: "desc"},
      ],
      loadingStatus: false,
      actionHistory: [],
      tableColumns: [
        {key: "details", label: "Details", sortable: false},
        {key: "call_date", label: "Record Timestamp", sortable: true, sortDirection: "desc"},
        {key: "calling_number", label: "Calling Number", sortable: true, sortDirection: "desc"},
        {key: "called_number", label: "Called Number", sortable: true, sortDirection: "desc"},
        {key: "event_type", label: "Event Type", sortable: true, sortDirection: "desc"},
        {key: "error_code", label: "Error Code", sortable: true, sortDirection: "desc"},
        {key: "ims_charging_identifer", label: "IMS Charging Id", sortable: true, sortDirection: "desc"},
      ],
      tableData: [],
      totalRows: 0,
      currentPage: 1,
      pageOptions: [10, 25, 50, 100],
      perPage: 10,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      modalContent: "",
      copiedMessage: "",
      copiedError: "",
      popOverContent: "",
      customer: "",
      searchFilter: "",
      exportDataTitle: "RF Report",
    };
  },

  computed: {

    disabledSearch() {
      return false;
      if (!this.causeCodeState || !this.callingNumberState || !this.calledNumberState || !this.fromDateState || !this.toDateState) {
        return true;
      } else {
        return false;
      }
    },

    causeCodeState() {
      this.queryForm.causeCode = this.queryForm.causeCode.replace(/\D/g, '');
      if (this.queryForm.causeCode.length < 1 || this.queryForm.causeCode >= 0) {
        return true;
      } else {
        return false;
      }
    },

    callingNumberState() {
      this.queryForm.callingNumber = this.queryForm.callingNumber.replace(/\D/g, '');
      if (this.queryForm.callingNumber.length < 1 || (this.queryForm.callingNumber.length > 2 && this.queryForm.callingNumber > 9)) {
        return true;
      } else {
        return false;
      }
    },

    calledNumberState() {
      this.queryForm.calledNumber = this.queryForm.calledNumber.replace(/\D/g, '');
      if (this.queryForm.calledNumber.length < 1 || (this.queryForm.calledNumber.length > 2 && this.queryForm.calledNumber > 9)) {
        return true;
      } else {
        return false;
      }
    },

    fromDateState() {
      return moment(this.queryForm.fromDate).isValid();
    },

    toDateState() {
      return moment(this.queryForm.toDate).isValid();
    },

    fromDate() {
      //moment also supports: .startOf('day')
      switch (this.selected) {
        case "mostRecent":
          this.queryForm.fromDate = moment().subtract(this.subSelected, 'minute').format('YYYY-MM-DD HH:mm:ss')
          this.queryForm.toDate = moment().format('YYYY-MM-DD HH:mm:ss');
          break;
        case "today":
          this.queryForm.fromDate = moment().format('YYYY-MM-DD') + " " + this.startTime;
          this.queryForm.toDate = moment().format('YYYY-MM-DD') + " " + this.endTime;
          break;
        case "yesterday":
          this.queryForm.fromDate = moment().subtract(1, 'day').format('YYYY-MM-DD') + " " + this.startTime;
          this.queryForm.toDate = moment().subtract(1, 'day').format('YYYY-MM-DD') + " " + this.endTime;
          break;
        case "customDate":
          this.queryForm.fromDate = moment(this.customDay).format('YYYY-MM-DD') + " " + this.startTime;
          this.queryForm.toDate = moment(this.customDay).format('YYYY-MM-DD') + " " + this.endTime;
          break;
        case "customRange":
          this.queryForm.fromDate = moment(this.customFromDate).format('YYYY-MM-DD HH:mm:ss');
          this.queryForm.toDate = moment(this.customToDate).format('YYYY-MM-DD HH:mm:ss');
          break;
        default:
          break;
      }
      console.log('fromDate', this.queryForm.fromDate);
      console.log('toDate', this.queryForm.toDate);
      return this.queryForm.fromDate;
    },

    mostRecentSubVal() {
      if (this.selected === "mostRecent") {
        return true;
      } else {
        return false;
      }
    },

    todaySubVal() {
      if (this.selected === "today") {
        return true;
      } else if (this.selected === "yesterday") {
        return true;
      } else if (this.selected === "customDate") {
        return true;
      } else {
        return false;
      }
    },

    customSubVal() {
      if (this.selected === "customRange") {
        return true;
      } else {
        return false;
      }
    },

  },

  mounted() {
    this.startTime = "00:00:00";
    this.endTime = "23:59:59";
    this.customer = commonService.toProperCase(process.env.VUE_APP_CLIENT);
  },

  methods: {

    searchSubmit() {
      this.rfReportDisplayStatus = true;
      this.loadingStatus = true;
      console.log("searchSubmit: " + JSON.stringify(this.queryForm));
      // validate data
      if (!this.fromDate || (this.queryForm.callingNumber.length < 1 && this.queryForm.calledNumber.length < 1)) {

        this.$toast(
            {
              component: ToastVue,
              props: {
                title: `Error`,
                description: 'Missing a calling number, called number or invalid date range',
              },
            },
            {
              type: `warning`,
            }
        );
        this.tableData = [];
        this.rfReportDisplayStatus = false;
        this.loadingStatus = false;
        return;
      }
      //index, from_dt, to_dt, from_msisdn, to_msisdn, cause_code, result_type
      let client = process.env.VUE_APP_CLIENT;
      let query = {
        index: `${client}-rf-*`,
        from_dt: this.queryForm.fromDate,
        to_dt: this.queryForm.toDate,
        from_msisdn: this.queryForm.callingNumber.length > 0 ? this.queryForm.callingNumber : "",
        to_msisdn: this.queryForm.calledNumber.length > 0 ? this.queryForm.calledNumber : "",
        cause_code: this.queryForm.causeCode.length > 0 ? this.queryForm.causeCode : "",
        result_type: this.queryForm.result_type, //table, graph, map
      }
      this.searchFilter = `${this.queryForm.callingNumber},${this.queryForm.calledNumber},${this.queryForm.fromDate}-${this.queryForm.toDate},${this.queryForm.causeCode}`;
      // call the api search
      rfDashboardService.getRfQuery(query).then(res => {
        if (res.hasOwnProperty('hits')) {
          this.processResults(res.hits.hits)
        }
        this.loadingStatus = false;
      }).catch(e => {
        console.error(e);
        this.$toast(
            {
              component: ToastVue,
              props: {
                title: `Error`,
                description: e.message,
              },
            },
            {
              type: `warning`,
            }
        );
        this.tableData = [];
        this.rfReportDisplayStatus = false;
        this.loadingStatus = false;
        return;
      });

    },

    processResults(data) {
      //debugger;
      let arr = [];
      try {
        // if (this.formData.type=='graph') {
        //   //set the categories base upon the distinct cause-codes
        //   this.chartOptions.xAxis.categories=['1', '2', '3']; //dates
        //   //this.chartOptions.xAxis.categories = [...new Set(data.map(item => item.fields["Cause-Code"]))];
        //   //set the series
        //   //this.chartOptions.series=[];
        //   this.chartOptions.series= [{
        //     name: 'BPL',
        //     data: [3, 5, 1, 13]
        //   }, {
        //     name: 'FA Cup',
        //     data: [14, 8, 8, 12]
        //   }, {
        //     name: 'CL',
        //     data: [0, 2, 6, 3]
        //   }]
        // }
        // map the resutls to our structure
        data.map(item => {
          //debugger
          let obj = {};
          obj.id = item._id;
          obj.call_date = String(item.fields["TIMESTAMP"]);
          // obj.calling_number = item.fields["calling-party.number"] ? String(item.fields["calling-party.number"]) : "";
          // if (obj.calling_number=="") obj.calling_number = item.fields["Calling_Party_Address"] ? String(item.fields["Calling_Party_Address"]) : "";
          obj.calling_number = item.fields["Calling_Party_Address"] ? String(item.fields["Calling_Party_Address"]) : "";
          //obj.calling_number = this.parsePhone(obj.calling_number);
          obj.called_number = item.fields["Called_Party_Address"] ? String(item.fields["Called_Party_Address"]) : "";
          //obj.called_number = this.parsePhone(obj.called_number);
          obj.error_code = item.fields["Cause-Code"] ? String(item.fields["Cause-Code"]) : "";
          obj.event_type = item.fields["Event_Type"] ? String(item.fields["Event_Type"]) : "";
          obj.ims_charging_identifer = item.fields["IMS_Charging_Identifier"] ? String(item.fields["IMS_Charging_Identifier"]) : "";
          obj.response = item;
          arr.push(obj);
        });
      } catch (e) {
        console.error(e);
        arr = [];
      }
      this.tableData = arr;

      this.totalRows = this.tableData.length;
      this.getTotalRows();


    },

    parsePhone(str) {
      let newStr = String(str);
      newStr = String(newStr.match(/[0-9 , \.]+/g));
      if (newStr.length < 10) return str;
      if (newStr.length > 10) newStr = newStr.substring(0, 10);
      if (!newStr.startsWith("1")) newStr = "1" + newStr;
      if (!newStr.includes("+")) newStr = "+" + newStr;
      return newStr;
    },

    tableDataCopy() {
      this.popOverContent = "Copied " + this.totalRows + " rows to clipboard";
      setTimeout(() => {
        this.$refs.popover.$emit("close");
      }, 2000);
    },

    generatePDF() {
      let doc = new jsPDF();
      doc.text(JSON.stringify(this.tableData), 10, 10);
      doc.save(this.exportDataTitle + ".pdf");
    },

    changePageOption(perPage) {
    },
    getTotalRows() {
      if (this.perPage > this.totalRows) {
        this.fromPage = this.totalRows;
      } else {
        this.fromPage = this.perPage;
      }
    },
    startPage() {
      return pagination.startPageFunc(this.currentPage, this.perPage)
    },
    lastPage() {
      return pagination.lastPageFunc(this.currentPage, this.perPage, this.totalRows)
    },

    showModal(content) {
      this.modalContent = content;
      console.log("content:", content);
      try {
        this.tbContent = Object.entries(content.item.response.fields);
      } catch (e) {
        console.error(e);
        this.tbContent = [];
      }
      this.$bvModal.show('rf-details_modal');
    },

    printJson(text) {
      return coreutils.formatJson(text);
    },


  }
};

//test data
//date:     2023-08-04
//msisdn:  4062631807

</script>
<style scoped>
/*Fix the control disabled text color*/
.form-control {
  color: #000000FF !important;
}
</style>

